import 'whatwg-fetch';

import {
    GET_STUDENT_LIST_FAIL,
    GET_STUDENT_LIST_INITIATE,
    GET_STUDENT_LIST_SUCCESS
} from '../constants/actionTypes'

export const getStudentList = () => {
    return (dispatch) => {
        dispatch({type: GET_STUDENT_LIST_INITIATE});
        fetch(API_SERVER+'/api/student_lists/new', {
            'credentials': 'same-origin'
        })
            .then(function (response) {
                return response.json()
            })
            .then(function (json) {
                dispatch({type: GET_STUDENT_LIST_SUCCESS, payload: {data: json}});
            })
            .catch(function (response) {
                dispatch({type: GET_STUDENT_LIST_FAIL})
            });
    }
}


// WEBPACK FOOTER //
// ./src/dashboards_redux/actions/getStudentListAction.jsx